import { Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
import { map } from 'rxjs/operators';
import { PeriodicReportsTurnsDaoService } from 'src/app/dao/turns-dao-services/periodic-reports-turns-dao-service/periodic-reports-turns-dao.service';
import { GeneratedPeriodicReport, PeriodicReportConfig, PeriodicReportConfigRequest } from 'src/app/models/turns-models/periodic-report.model';
import { UserService } from 'src/app/services/user-service/user.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Injectable({ providedIn: 'root' })
export class PeriodicReportsTurnsService {
  private readonly accessToken = ['TUR', 'CTR'];

  constructor(private dao: PeriodicReportsTurnsDaoService,
              private storage: UserStorageService,
              private user: UserService) { }

  private allowed() {
    return this.user.accessGranted(this.accessToken);
  }

  private context() { return this.storage.getContext(); }
  private lang() { return this.storage.getLang(); }
  private udid() { return this.storage.getUDID(); }

  public configs() {
    if (!this.allowed()) { return EMPTY; }
    return this.dao.configs(this.context(), this.lang(), this.udid()).pipe(
      map(response => response.data.configs as PeriodicReportConfig[])
    );
  }

  public generated() {
    if (!this.allowed()) { return EMPTY; }
    return this.dao.generated(this.context(), this.lang(), this.udid()).pipe(
      map(response => response.data.reports as GeneratedPeriodicReport[])
    );
  }

  public detail(internalId: string) {
    if (!this.allowed()) { return EMPTY; }
    return this.dao.detail(this.context(), this.lang(), this.udid(), internalId).pipe(
      map(response => response.data as PeriodicReportConfig)
    );
  }

  public save(request: PeriodicReportConfigRequest) {
    if (!this.allowed()) { return EMPTY; }
    return this.dao.save(this.context(), this.lang(), this.udid(), request).pipe(
      map(response => response.data as PeriodicReportConfig)
    );
  }

  public active(internalId: string, active: boolean) {
    if (!this.allowed()) { return EMPTY; }
    return this.dao.active(this.context(), this.lang(), this.udid(), internalId, active).pipe(
      map(response => response.data as PeriodicReportConfig)
    );
  }

  public deleteConfig(internalId: string) {
    if (!this.allowed()) { return EMPTY; }
    return this.dao.deleteConfig(this.context(), this.lang(), this.udid(), internalId);
  }

  public generate(internalId: string) {
    if (!this.allowed()) { return EMPTY; }
    return this.dao.generate(this.context(), this.lang(), this.udid(), internalId).pipe(
      map(response => response.data)
    );
  }
}
